import { Box } from '@trmediaab/zebra';
import { Component, Fragment } from 'react';

import { PageTitle, Preamble } from '~/components/Elements';
import PageMeta from '~/components/PageMeta';
import Start from '~/containers/Start';

import RenderAllStarts from './RenderAllStarts';

class AllStarts extends Component {
  render() {
    return (
      <Fragment>
        <PageMeta meta={{ title: 'Till start' }} />

        <Box px={{ _: 3, md: 0 }}>
          <PageTitle>Till start</PageTitle>

          <Preamble>
            Sök efter en start genom att skriva in hästens namn
          </Preamble>

          <Start
            id="tillstart"
            render={allStarts => <RenderAllStarts allStarts={allStarts} />}
          />
        </Box>
      </Fragment>
    );
  }
}
export default AllStarts;
